import Vue from 'vue';
import moment from 'moment';

// leave the export, even if you don't use it
Vue.filter('datetime', (value: Date) => {
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm');
  } else {
    return '';
  }
});

Vue.filter('date', (value: Date) => {
  if (value) {
    return moment(value).format('YYYY-MM-DD');
  } else {
    return '';
  }
});

Vue.filter('date2', (value: Date) => {
  if (value) {
    return moment(value).format('YYYY/MM/DD');
  } else {
    return '';
  }
});

Vue.filter('dateForString', (value: string) => {
  if (value) {
    return moment(value).format('YYYY-MM-DD');
  } else {
    return '';
  }
});

Vue.filter('dateWithDot', (value: Date) => {
  if (value) {
    return moment(value).format('YYYY.MM.DD');
  } else {
    return '';
  }
});
